import { render, staticRenderFns } from "./CustomPendryMethods.vue?vue&type=template&id=f59985a2&"
import script from "./CustomPendryMethods.vue?vue&type=script&lang=js&"
export * from "./CustomPendryMethods.vue?vue&type=script&lang=js&"
import style0 from "./CustomPendryMethods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports